export default function Pill({
  children,
  onClick,
  active = false,
  variant = "primary",
  size = "md",
  className = "",
}) {
  const base = "font-sans rounded-full tracking-wide flex items-center justify-center hover:bg-[var(--primary-muted)] transition-all duration-300";

  const sizes = {
    xs: "min-w-10 h-4 text-[10px] px-1 py-1",
    sm: "min-w-10 h-4 text-xs px-1.5 py-1",
    md: "min-w-15 h-5 text-sm px-2.5 py-1.5",
    lg: "min-w-20 h-6 text-sm px-3.5 py-2",

  };

  const variants = {
    primary: {
      active: {
        bg: "var(--primary-muted)",
        color: "var(--primary)",
        // border: "#c9a96e",
        fontWeight: 600,

      },
      inactive: {
        // bg: "var(--primary-muted)",
        color: "var(--primary)",
        border: "transparent",
        fontWeight: 400,
      },
    },

    neutral: {
        active: {
          bg: "rgba(255,255,255,0.1)",
          color: "#fff",
          border: "rgba(255,255,255,0.25)",
        },
        inactive: {
          bg: "rgba(255,255,255,0.05)",
          color: "rgba(255,255,255,0.4)",
          border: "transparent",
        },
      },

    // success: {
    //   active: {
    //     bg: "rgba(16,185,129,0.15)",
    //     color: "#10b981",
    //     border: "rgba(16,185,129,0.4)",
    //   },
    //   inactive: {
    //     bg: "rgba(16,185,129,0.06)",
    //     color: "rgba(16,185,129,0.6)",
    //     border: "transparent",
    //   },
    // },

    // danger: {
    //   active: {
    //     bg: "rgba(239,68,68,0.15)",
    //     color: "#ef4444",
    //     border: "rgba(239,68,68,0.4)",
    //   },
    //   inactive: {
    //     bg: "rgba(239,68,68,0.06)",
    //     color: "rgba(239,68,68,0.6)",
    //     border: "transparent",
    //   },
    // },
  };

  const styleSet = variants[variant] || variants.primary;
  const state = active ? styleSet.active : styleSet.inactive;

  return (
    <button
      onClick={onClick}
      className={`${base} ${sizes[size]} ${className}`}
      style={{
        background: state.bg,
        color: state.color,
        borderColor: state.border,
        fontWeight: state.fontWeight || "normal",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {children}
    </button>
  );
}
